
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boilerplate",
      function () {
        return require("private-next-pages/boilerplate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boilerplate"])
      });
    }
  